import Joi from 'joi';

const baseSchema = {
  userName: Joi.string().required(),
  firstName: Joi.string().optional().max(50).allow(''),
  lastName: Joi.string().optional().max(50).allow(''),
  email: Joi.string()
    .allow('')
    .email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } })
    .required(),
  DOB: Joi.string().optional().allow(''),
  gender: Joi.string().optional().allow(''),
  mobilePhone: Joi.string()
    .regex(
      /^(?:\+?61|0)4 ?(?:(?:[01] ?[0-9]|2 ?[0-57-9]|3 ?[1-9]|4 ?[7-9]|5 ?[018]) ?[0-9]|3 ?0 ?[0-5])(?: ?[0-9]){5}$/
    )
    .optional()
    .allow(''),
  unit: Joi.string().optional().allow(''),
  street: Joi.string().optional().allow(''),
  suburb: Joi.string().optional().allow(''),
  state: Joi.string().optional().allow(''),
  // avatar: Joi.string().optional().allow(''),
  personalIntro: Joi.string().optional().allow(''),
};

export const userSchema = Joi.object({
  ...baseSchema,
});
